// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_24p9j","logo":"index_logo_DQiZV"};